/* ================================================================
   W+S Premium AJAX Cart Drawer  —  ws-cart.js
   ================================================================ */
(function () {
  'use strict';

  var TIMER_SECONDS   = 600;    // 10 min countdown

  /* ── State ──────────────────────────────────────────────────── */
  var S = {
    open:          false,
    timerInterval: null,
    timerLeft:     TIMER_SECONDS,
    cart:          null
  };

  /* ── DOM shortcuts ──────────────────────────────────────────── */
  function $$(id) { return document.getElementById(id); }

  /* ── Bootstrap ──────────────────────────────────────────────── */
  function init() {
    var closeBtn = $$('ws-cd-close');
    var overlay  = $$('ws-cd-overlay');
    var discBtn  = $$('ws-cd-disc-btn');
    var discInp  = $$('ws-cd-disc-inp');

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);
    if (discBtn)  discBtn.addEventListener('click', applyDiscount);
    if (discInp)  discInp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyDiscount();
    });

    /* Cart icon: intercept in capture phase so it fires before theme handlers */
    document.addEventListener('click', interceptCartIcon, true);

    /* ATC forms from the WS custom template (id starts with "wm-form-") */
    document.addEventListener('submit', interceptWsForm, true);

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && S.open) closeDrawer();
    });

    /* Custom event dispatched by Buy-Now handler */
    document.addEventListener('ws:open:cart', function () { openDrawer(); });
  }

  /* ── Cart icon intercept ────────────────────────────────────── */
  function interceptCartIcon(e) {
    /* Match the Avada/Turbo cart icon link or any /cart link */
    var el = e.target.closest(
      'a[href="/cart"],' +
      '.navCart-link,' +
      '.navUser-action--cart,' +
      '.icon-cart-link,' +
      '[data-cart-trigger],' +
      '.cart-icon-bubble,' +
      '.header__icon--cart'
    );
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  }

  /* ── ATC form intercept ─────────────────────────────────────── */
  function interceptWsForm(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isWsForm   = form.id && form.id.indexOf('wm-form-') === 0;
    var isCartForm = action.indexOf('/cart/add') !== -1;
    if (!isWsForm && !isCartForm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitWsForm(form);
  }

  function submitWsForm(form) {
    var idInp  = form.querySelector('[name="id"]');
    var qtyInp = form.querySelector('[name="quantity"]');
    var spInp  = form.querySelector('[name="selling_plan"]');

    if (!idInp || !idInp.value) return;

    var item = {
      id:       parseInt(idInp.value, 10),
      quantity: parseInt(qtyInp ? qtyInp.value : '1', 10) || 1
    };

    /* Include selling_plan only when the field is enabled (Subscribe mode) */
    if (spInp && !spInp.disabled && spInp.value) {
      item.selling_plan = parseInt(spInp.value, 10);
    }

    showLoading(true);
    fetch('/cart/add.js', {
      method:      'POST',
      credentials: 'same-origin',
      headers:     { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:        JSON.stringify({ items: [item] })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    })
    .then(function () { return fetchCart(); })
    .then(function () {
      showLoading(false);
      openDrawer();
    })
    .catch(function (err) {
      showLoading(false);
      console.error('[ws-cart] add error', err);
      /* Fallback: plain form submit to cart page */
      form.setAttribute('data-bypass', '1');
      form.submit();
    });
  }

  /* ── Programmatic add (called by Buy Now, etc.) ─────────────── */
  function wsCartAddItems(items) {
    return fetch('/cart/add.js', {
      method:      'POST',
      credentials: 'same-origin',
      headers:     { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:        JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); });
  }

  /* ── Change line item quantity ──────────────────────────────── */
  function wsCartChange(line, quantity) {
    fetch('/cart/change.js', {
      method:      'POST',
      credentials: 'same-origin',
      headers:     { 'Content-Type': 'application/json' },
      body:        JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      S.cart = cart;
      renderCart(cart);
    });
  }

  /* ── Fetch cart ─────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        S.cart = cart;
        renderCart(cart);
        return cart;
      });
  }

  /* ── Open / Close drawer ────────────────────────────────────── */
  function openDrawer() {
    showLoading(true);
    fetchCart().then(function () {
      showLoading(false);
      var ov = $$('ws-cd-overlay');
      var dr = $$('ws-cd-drawer');
      if (ov) ov.classList.add('ws-open');
      if (dr) dr.classList.add('ws-open');
      document.body.style.overflow = 'hidden';
      S.open = true;
      startTimer();
    });
  }

  function closeDrawer() {
    var ov = $$('ws-cd-overlay');
    var dr = $$('ws-cd-drawer');
    if (ov) ov.classList.remove('ws-open');
    if (dr) dr.classList.remove('ws-open');
    document.body.style.overflow = '';
    S.open = false;
    stopTimer();
  }

  /* ── Timer ──────────────────────────────────────────────────── */
  function startTimer() {
    S.timerLeft = TIMER_SECONDS;
    stopTimer();
    tickClock();
    S.timerInterval = setInterval(function () {
      S.timerLeft--;
      if (S.timerLeft < 0) S.timerLeft = TIMER_SECONDS;
      tickClock();
    }, 1000);
  }

  function stopTimer() {
    if (S.timerInterval) clearInterval(S.timerInterval);
    S.timerInterval = null;
  }

  function tickClock() {
    var el = $$('ws-cd-clock');
    if (!el) return;
    var m = Math.floor(S.timerLeft / 60);
    var s = S.timerLeft % 60;
    el.textContent = pad(m) + ':' + pad(s);
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ── Render cart ────────────────────────────────────────────── */
  function renderCart(cart) {
    var has = cart.item_count > 0;

    /* Visibility toggles */
    toggle('ws-cd-empty',   !has);
    toggle('ws-cd-ft',       has);
    toggle('ws-cd-disc',     has);
    toggle('ws-cd-timer',    has);

    /* Header count — "Cart • X items" */
    var badge = $$('ws-cd-hd-count');
    if (badge) {
      badge.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    }

    /* Prices */
    var total = cart.total_price;
    setText('ws-cd-subtotal', fmt(total));
    setText('ws-cd-ckprice',  fmt(total));

    /* Theme cart count badges */
    updateThemeCount(cart.item_count);

    var itemsEl = $$('ws-cd-items');
    if (!itemsEl) return;

    if (!has) { itemsEl.innerHTML = ''; return; }

    itemsEl.innerHTML = cart.items.map(renderItem).join('');
  }

  function renderItem(item, idx) {
    var line = idx + 1;

    var img = item.image
      ? item.image.replace(/(\.[^.?]+)(\?.*)?$/, '_100x100$1$2')
      : '';
    if (!img && item.image) img = item.image;

    var imgHtml = img
      ? '<a href="' + item.url + '"><img class="ws-cd-item-img" src="' + img + '" alt="' + esc(item.product_title) + '" loading="lazy"></a>'
      : '<div class="ws-cd-item-img-ph">💧</div>';

    var varHtml = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      varHtml += '<div class="ws-cd-item-variant">' + esc(item.variant_title) + '</div>';
    }
    if (item.selling_plan_allocation) {
      varHtml += '<div class="ws-cd-item-sub">'
        + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg> '
        + esc(item.selling_plan_allocation.selling_plan.name)
        + '</div>';
    }

    var priceHtml = fmt(item.final_line_price);
    if (item.original_line_price > item.final_line_price) {
      priceHtml = '<span class="ws-cd-item-orig">' + fmt(item.original_line_price) + '</span> ' + priceHtml;
    }

    return '<div class="ws-cd-item">'
      + '<div class="ws-cd-item-imgw">' + imgHtml + '</div>'
      + '<div class="ws-cd-item-info">'
        + '<div class="ws-cd-item-top">'
          + '<div class="ws-cd-item-title">' + esc(item.product_title) + '</div>'
          + '<button class="ws-cd-rm" onclick="wsCartChange(' + line + ',0)" aria-label="Remove item">'
            + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
          + '</button>'
        + '</div>'
        + varHtml
        + '<div class="ws-cd-item-bottom">'
          + '<div class="ws-cd-qty">'
            + '<button class="ws-cd-qb" onclick="wsCartChange(' + line + ',' + Math.max(0, item.quantity - 1) + ')">&#8722;</button>'
            + '<span class="ws-cd-qv">' + item.quantity + '</span>'
            + '<button class="ws-cd-qb" onclick="wsCartChange(' + line + ',' + (item.quantity + 1) + ')">+</button>'
          + '</div>'
          + '<div class="ws-cd-item-price">' + priceHtml + '</div>'
        + '</div>'
      + '</div>'
    + '</div>';
  }

  /* ── Theme cart count update ────────────────────────────────── */
  function updateThemeCount(n) {
    var sels = [
      '.cart-count', '.cart__count', '.cart-item-count',
      '[data-cart-count]', '.navCart-count', '.js-cart-count',
      '.cart-count-bubble span', '.cart-link .count'
    ];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) {
        el.textContent = n;
      });
    });
  }

  /* ── Discount apply ─────────────────────────────────────────── */
  function applyDiscount() {
    var inp = $$('ws-cd-disc-inp');
    var msg = $$('ws-cd-disc-msg');
    if (!inp || !inp.value.trim()) return;
    var code = inp.value.trim().toUpperCase();
    if (msg) { msg.textContent = 'Applying…'; msg.className = 'ws-cd-disc-msg'; }
    window.location.href = '/discount/' + encodeURIComponent(code)
      + '?redirect=' + encodeURIComponent(window.location.pathname);
  }

  /* ── Loading state ──────────────────────────────────────────── */
  function showLoading(on) {
    toggle('ws-cd-loading', on);
    var el = $$('ws-cd-items');
    if (el) el.style.opacity = on ? '.3' : '1';
  }

  /* ── Utilities ──────────────────────────────────────────────── */
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) {
    return (s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function toggle(id, show) {
    var el = $$(id);
    if (el) el.style.display = show ? '' : 'none';
  }
  function setText(id, v) {
    var el = $$(id);
    if (el) el.textContent = v;
  }

  /* ── Public API ─────────────────────────────────────────────── */
  window.wsCartOpen     = openDrawer;
  window.wsCartClose    = closeDrawer;
  window.wsCartChange   = wsCartChange;
  window.wsCartAddItems = wsCartAddItems;

  /* ── Boot ───────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
